import { Avatar, AvatarImage } from '@/components/ui/avatar'

interface ProfileCardProps {
  displayName: string
  username: string
  avatarUrl?: string
  fansCount?: number
  followingCount?: number
  className?: string
}

export const ProfileCard = ({
  displayName,
  username,
  avatarUrl,
  fansCount = 0,
  followingCount = 0,
  className = '',
}: ProfileCardProps) => {
  return (
    <div className={`space-y-4 rounded-md bg-card p-3 ${className}`}>
      <div className="flex flex-col gap-4">
        <Avatar className="h-14 w-14">
          {avatarUrl ? (
            <AvatarImage
              src={avatarUrl}
              alt={displayName}
              className="object-cover"
            />
          ) : (
            <div className="bg-primary-500 w-full h-full flex items-center justify-center text-2xl font-medium">
              {displayName?.slice(0, 1).toUpperCase()}
            </div>
          )}
        </Avatar>

        <div className="flex flex-col gap-4">
          <h2 className="text-xl font-semibold">{displayName}</h2>
          <p className="text-sm text-secondary-300">@{username}</p>
        </div>

        <div className="flex  gap-6">
          <div className="flex flex-col items-center">
            <span className="text-lg font-semibold">{fansCount}</span>
            <span className="text-sm text-secondary-300">Fans</span>
          </div>
          <div className="flex flex-col items-center">
            <span className="text-lg font-semibold">{followingCount}</span>
            <span className="text-sm text-secondary-300">Following</span>
          </div>
        </div>
      </div>
    </div>
  )
}
